import { Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/header/Header";
import Nav from "./components/navbar/Nav";
import About from "./components/about/About";
import Experience from "./components/Experience/Experience";
import Portfolio from "./components/portfolio/Portfolio";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Services from "./components/services/Services";
import Testimonials from "./components/testimonials/Testimonials";
import News from "./components/News/News";
import CRMBuzzCaseStudy from "./pages/CRMBuzz/CRMBuzzCaseStudy";
import BPMFlowCaseStudy from "./pages/BPMFlow/BPMFlowCaseStudy";
import ApliviaCaseStudy from "./pages/Aplivia/ApliviaCaseStudy";
import ImmoFlowCaseStudy from "./pages/ImmoFlow/ImmoFlowCaseStudy";
import CodeQueryCaseStudy from "./pages/CodeQuery/CodeQueryCaseStudy";

function Home() {
  return (
    <>
      <Nav />
      <Header />
      <About />
      <Services/>
      <Experience />
      <Portfolio />
      <Testimonials/>
      <News/>
      <Contact />
      <Footer/>
    </>
  );
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects/crmbuzz" element={<CRMBuzzCaseStudy />} />
        <Route path="/projects/bpmflow" element={<BPMFlowCaseStudy />} />
        <Route path="/projects/aplivia" element={<ApliviaCaseStudy />} />
        <Route path="/projects/immoflow" element={<ImmoFlowCaseStudy />} />
        <Route path="/projects/codequery" element={<CodeQueryCaseStudy />} />
      </Routes>
      <Analytics />
    </>
  );
}

export default App;
